import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=9f2fb710&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&id=9f2fb710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2fb710",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/Question.vue
// module id = null
// module chunks = 